import React, {useEffect, useState} from "react";
import {Button, Checkbox, Col, Modal, notification, Row, Spin} from "antd";
import {companyService} from "../../../services";
import InputField from "../../input-field";
import i18n from "../../../i18n";

export default function ModalCompanySettingsByConsignor({isShow, setIsShow, companyID, companyType = '', companyTypeName = '', legalEnityId, id: orderId, isOwner}) {
  const [loading, setLoading] = useState(true);
  const [fieldsErrors, setFieldsErrors] = useState([]);
  const [settingsData, setSettingsData] = useState({});
  if (companyTypeName && companyTypeName.includes("Диспетчер")) {
    companyTypeName = companyTypeName.replace(/Диспетчер/g, "Экспедитор");
  }
  useEffect(() => {
    if (companyID && isShow) {
      setLoading(true);
      companyService.getCompanySettingsByConsignor(companyID)
        .then(resp => {
          setSettingsData(resp);
          setLoading(false);
        })
        .catch((err) => {
          notification.error({
            message: i18n.t('components.notification.titles.getCompanySettingsByConsignor'),
            description: err,
          });
        });
    }
  }, [companyID, isShow]);

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField][0]
      : null;
  };

  const handleSave = () => {
    if (settingsData && companyID) {
      setLoading(true);
      companyService.saveCompanySettingsByConsignor(settingsData)
        .then(resp => {
          notification.success({
            message: i18n.t('components.notification.titles.saveCompanySettingsByConsignor'),
            description: resp.message,
          });
          setLoading(false);
        })
        .catch(err => {
          notification.error({
            message: i18n.t('components.notification.titles.saveCompanySettingsByConsignor'),
            description: err,
          });
          setLoading(false);
        });
    }
  };

  const handleBecomeConsignor = () => {
    if (!companyID ) return;

    Modal.confirm({
      title: 'Изменение типа компании',
      width: 720,
      centered: true,
      content: (
        <div style={{fontSize: '14px', lineHeight: 1.5}}>
          <div style={{fontWeight: 700, color: '#d46b08', marginBottom: '8px'}}>
            Внимание!
          </div>
          <div style={{marginBottom: '10px'}}>
            После изменения типа на <b>грузовладельца</b>, обратная замена будет невозможна.
          </div>
          <div style={{fontWeight: 600}}>
            Вы действительно хотите изменить тип компании на грузовладельца?
          </div>
        </div>
      ),
      okText: 'Да',
      cancelText: 'Нет',
      onOk: () => {
        setLoading(true);
        return companyService.becomeConsignor(legalEnityId)
          .then((resp) => {
            notification.success({
              message: 'Тип компании изменён',
              description: resp && resp.message ? resp.message : '',
            });
            setIsShow(false);
          })
          .catch((err) => {
            notification.error({
              message: 'Ошибка изменения типа компании',
              description: err,
            });
            throw err;
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };

  const handleChangeType = (nextCompanyTypeName) => {
    if (!orderId) {
      notification.error({
        message: 'Ошибка',
        description: 'Не определён идентификатор согласования (orderId)',
      });
      return;
    }

    Modal.confirm({
      title: 'Подтверждение изменения типа компании',
      width: 520,
      centered: true,
      content: (
          <div style={{ fontSize: '14px', lineHeight: 1.5 }}>
            <div style={{ marginBottom: '10px' }}>
              Вы уверены, что хотите изменить тип компании ?
            </div>
            <div style={{ color: '#d46b08', fontWeight: 500 }}>
              Внимание! Это действие может повлиять на доступные функции компании.
            </div>
          </div>
      ),
      okText: 'Да',
      cancelText: 'Нет',
      onOk: () => {
        setLoading(true);
        companyService.changeTypeByOrderId(orderId, nextCompanyTypeName)
            .then((resp) => {
              notification.success({
                message: 'Тип компании изменён',
                description: resp && resp.message ? resp.message : '',
              });
              setIsShow(false);
            })
            .catch((err) => {
              notification.error({
                message: 'Ошибка изменения типа компании',
                description: err,
              });
            })
            .finally(() => {
              setLoading(false);
            });
      },
    });
  };

  let bigButtonStyle = {
    width: '200px',
    height: '43px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px'
  };
  let secondaryButtonStyle = {
    width: '200px',
    height: '43px',
    background: '#1CAA53',
    borderColor: '#1CAA53',
    color: '#fff',
    position: 'static',
    borderRadius: '10px'
  };
  return (
    <Modal
      title={i18n.t('modals.modalCompanySettingsByConsignor.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={<Button htmlType="submit" key="submit" type="primary" style={bigButtonStyle}
                      onClick={() => handleSave()} disabled={loading}>{i18n.t('main.buttons.save')}</Button>}
    >
      
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Row gutter={[48, 24]}>
          <Col span={24}>
            <p>{i18n.t('modals.modalCompanySettingsByConsignor.fields.type.label')}: {companyTypeName ? (<b>{companyTypeName}</b>) : i18n.t('modals.modalCompanySettingsByConsignor.errors.type')}</p>
          </Col>
          {(settingsData.accessToSwitchToConsignor && isOwner && (companyType !== 'Грузоотправитель' && companyType !== 'Диспетчер/Грузоотправитель' && companyType !== 'Перевозчик/Грузовладелец') ) &&
            <Col span={24}>
              <Button
                key="becomeConsignor"
                type="primary"
                style={secondaryButtonStyle}
                disabled={loading || !companyID }
                onClick={handleBecomeConsignor}
              >
                Сделать грузовладельцем
              </Button>
            </Col>
          }
          {(settingsData.accessToSwitchToConsignor && settingsData.isCanSwitchToConsignor && isOwner && (companyType === 'Грузоотправитель' || companyType === 'Диспетчер/Грузоотправитель') ) &&
              <Col span={24}>
                <Button
                    key="becomeConsignor"
                    type="primary"
                    style={secondaryButtonStyle}
                    disabled={loading || !companyID }
                    onClick={() => handleChangeType('Собственник автотранспорта')}
                  //  onClick={() => handleChangeType('Собственник/Грузовладелец')}
                >
                  Сделать Собственник/Грузовладелец
                </Button>
              </Col>
          }
          {(settingsData.accessToSwitchToConsignor && settingsData.isCanSwitchToConsignor && isOwner && (companyType === 'Грузоотправитель' || companyType === 'Перевозчик/Грузовладелец')  ) &&
              <Col span={24}>
                <Button
                    key="becomeConsignor"
                    type="primary"
                    style={secondaryButtonStyle}
                    disabled={loading || !companyID }
                    onClick={() => handleChangeType('Экспедитор')}
                  //  onClick={() => handleChangeType('Диспетчер/Грузовладелец')}
                >
                  Сделать Экспедитор/Грузовладелец
                </Button>
              </Col>
          }
          <Col span={8}>
            <InputField
              name="name"
              label={i18n.t('modals.modalCompanySettingsByConsignor.fields.name.label')}
              required={true}
              value={settingsData.newDeliveryDelay}
              setValue={(value) => {
                setSettingsData({...settingsData, newDeliveryDelay: value});
              }}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col span={8}>
            <Checkbox
              name="accreditedIntDeliveries"
              checked={settingsData.accreditationInternationalDeliveries}
              onChange={(e) => {
                setSettingsData({
                  ...settingsData,
                  accreditationInternationalDeliveries: e.target.checked
                });
              }}
              style={{fontSize: "10pt", paddingTop: "15px"}}
            >
              {i18n.t('modals.modalCompanySettingsByConsignor.fields.accreditedIntDeliveries.label')}
            </Checkbox>
          </Col>
          {/*{settingsData.accessToSwitchToConsignor &&*/}
          {/*  <Col span={8}>*/}
          {/*    <Checkbox*/}
          {/*      name="isCanSwitchToConsignor"*/}
          {/*      checked={settingsData.isCanSwitchToConsignor}*/}
          {/*      onChange={(e) => {*/}
          {/*        setSettingsData({*/}
          {/*          ...settingsData,*/}
          {/*          isCanSwitchToConsignor: e.target.checked*/}
          {/*        });*/}
          {/*      }}*/}
          {/*      style={{fontSize: "10pt", paddingTop: "15px"}}*/}
          {/*    >*/}
          {/*      {i18n.t('modals.modalCompanySettingsByConsignor.fields.isCanSwitchToConsignor.label')}*/}
          {/*    </Checkbox>*/}
          {/*  </Col>*/}
          {/*}*/}
        </Row>
      </Spin>
    </Modal>
  );
}
